<style>
#scadaPointCard .v--modal-box.v--modal {
  min-width: 600px !important;
  min-height: 320px !important;
}
#scadaPointCard .modal__content {
  overflow-y: auto !important;
}
.watch-icon {
  font-size: 14px;
  cursor: default;
}
#current-measures__container,
#archive-measures__container {
  width: 100%;
  margin-left: 0px;
  display: flex;
  justify-content: space-between;
}
</style>

<template>
  <Modal
    modalName="scadaPointCard"
    title="Karta punktu pomiarowego"
    @opened="open()"
    :module="module"
    @closed="close"
    :buttons="['']"
  >
    <v-layout v-if="currentPoint">
      <div class="list__container">
        <v-subheader class="font--primary subheader--first">Informacje ogólne</v-subheader>
        <ul
          class="values__list"
          style="list-style-type:none; padding-left: 0px;"
        >
          <v-layout xs12>
            <v-flex xs5>
              <li class="list__container--el">
                Nazwa punktu
                <span v-text="currentPoint.name"></span>
              </li>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <li class="list__container--el">
                Symbol punktu
                <span v-text="currentPoint.code"></span>
              </li>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs5>
              <li class="list__container--el">
                Opis
                <span v-text="currentPoint.description"></span>
              </li>
            </v-flex>
            <v-spacer />
          </v-layout>
        </ul>
        <v-subheader class="font--primary subheader--first">Dane bieżące</v-subheader>
        <p
          v-if="currentMeasures.length == 0"
          class="font--primary"
        >Brak danych bieżących</p>
        <ul
          v-else
          class="values__list"
          style="list-style-type:none; padding-left: 0px;"
        >
          <div
            v-if="isLoading"
            class="text-xs-center"
          >
            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </div>
          <span
            v-else
            v-for="(index, key) in currentMeasures"
            :key="key"
          >
            <v-layout xs12>
              <v-flex xs12>
                <li class="list__container--el">
                  <span id="current-measures__container">
                    <span>{{ currentNames[key] }}</span>
                    <span>
                      <span v-if="index.unit == 'Nie dotyczy' && (index.data[0].value == 0 || !index.data[0].value)">Brak aktywnych alarmów</span>
                      <span v-else-if="index.unit == 'Nie dotyczy' && index.data[0].value > 0">Aktywny alarm!</span>
                      <span v-else>{{index.data[0].value.toFixed(2)}} {{index.unit}}</span>
                      <v-icon
                        class="watch-icon"
                        :title="'Ostatnia aktualizacja: ' + index.data[0].time"
                      >watch_later</v-icon>
                    </span>
                  </span>
                </li>
              </v-flex>
            </v-layout>
          </span>
        </ul>

        <v-subheader class="font--primary subheader--first">Dane historyczne</v-subheader>
        <p
          v-if="archiveMeasures.length == 0"
          class="font--primary"
        >Brak danych historycznych</p>
        <ul
          v-else
          class="values__list"
          style="list-style-type:none; padding-left: 0px;"
        >
          <div
            v-if="isLoading"
            class="text-xs-center"
          >
            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </div>
          <v-layout
            v-else
            xs12
          >
            <v-flex xs12>
              <li
                class="list__container--el"
                v-for="(index, key) in archiveMeasures"
                :key="key"
              >
                <span id="archive-measures__container">
                  <span>{{ archiveNames[key] }}</span>
                  <span>
                    <v-icon
                      @click="showChart(index, archiveNames[key], archiveIDs[key])"
                      style="font-size:16px;"
                      title="Wyśiwetl dane historyczne"
                    >timeline</v-icon>
                  </span>
                </span>
              </li>
            </v-flex>
          </v-layout>
        </ul>
        <v-flex
          xs12
          align-left
        >
          <v-btn
            style="margin-left: 0; margin-top: 18px;"
            dark
            color="#2a579a"
            @click="openScadaAlarms"
          >
            Wyświetl historię alarmów
            <br>w systemie SCADA
            <v-icon style="font-size:24px; margin-left: 5px;">history</v-icon>
          </v-btn>
        </v-flex>

        <v-subheader class="font--primary subheader--first">Opcje</v-subheader>
        <v-layout xs12>
          <v-flex
            xs5
            align-left
          >
            <v-btn
              style="margin-left: 0;width: 253px;"
              dark
              color="#2a579a"
              @click="editScadaPoint"
            >
              Edytuj punkt pomiarowy
              <v-icon
                style="font-size:24px; margin-left: 25px;"
                v-if="$can('read', 'scada_edit')"
              >settings</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  props: {
    pointID: Number
  },
  data: () => ({
    // currentPoint: undefined,
    module: "scada",
    currentMeasures: [],
    currentNames: [],
    currentIDs: [],
    archiveMeasures: [],
    archiveNames: [],
    archiveIDs: [],
    tempID: undefined,
    isLoading: true
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    scadaAlarmsLink() {
      return this.$store.getters.getScadaAlarmsLink;
    },
    currentPoint() {
      return this.$store.getters.getCurrentScadaPoint;
    },
    scadaPoints() {
      return this.$store.getters.getScadaPoints;
    },
    scadaFeatures() {
      return this.$store.getters.getScadaFeaturesArr;
    }
  },
  methods: {
    open() {
      const self = this;
      this.currentMeasures = [];
      this.archiveMeasures = [];
      this.currentNames = [];
      this.archiveNames = [];
      this.currentIDs = [];
      this.archiveIDs = [];
      if(this.pointID) {
        this.tempID = this.pointID;
      }
      this.$store.dispatch("getScadaPoint", this.tempID).then(success => {
        if(success) {
          let feature = self.scadaFeatures.filter(obj => {
            return obj.getId() === self.tempID;
          })[0];
          feature.set("pressure", "Brak danych");
          feature.set("flow", "Brak danych");
          feature.set("alarms", "Brak danych");
          this.$root.$emit("changeScadaStyle", feature, "noAlarmInfoStyle");
          for(let i of self.currentPoint.measures) {
            if(!i.visible) {
              continue;
            }
            this.$store.dispatch("getMeasures", i.id).then(response => {
              if(response && response.data.length > 0) {
                if(
                  i.measure_type === "Dane bieżące" ||
                  i.measure_type === "Alarmy"
                ) {
                  self.currentMeasures.push(response);
                  if(response.unit === "[bar]" || response.unit === "[MPa]") {
                    feature.set(
                      "pressure",
                      `${response.data[0].value.toFixed(2)} ${response.unit}`
                    );
                  } else if(
                    response.unit === "[m3/h]" ||
                    response.unit === "[m3/doba]"
                  ) {
                    feature.set(
                      "flow",
                      `${response.data[0].value.toFixed(2)} ${response.unit}`
                    );
                  } else if(response.unit === "Nie dotyczy") {
                    if(
                      response.data[0].value === 0 ||
                      !response.data[0].value
                    ) {
                      feature.set("alarms", "Brak alarmów");
                      this.$root.$emit(
                        "changeScadaStyle",
                        feature,
                        "noAlarmStyle"
                      );
                    } else {
                      feature.set("alarms", "Aktywny alarm!");
                      this.$root.$emit(
                        "changeScadaStyle",
                        feature,
                        "alarmStyle"
                      );
                    }
                  }

                  self.currentNames.push(i.name);
                  self.currentIDs.push(i.id);
                } else {
                  self.archiveMeasures.push(response);
                  self.archiveNames.push(i.name);
                  self.archiveIDs.push(i.id);
                }
              } else if(!response) {
                self.$root.$emit(
                  "showSnackbar",
                  "red",
                  "Podczas ładowania serii pomiarowych wystąpił błąd"
                );
              }
            });
            self.isLoading = false;
            self.$root.$emit(
              "showSnackbar",
              "success",
              "Pobrano informacje o punkcie pomiarowym"
            );
          }
        } else {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas ładowania punktu pomiarowego wystąpił błąd"
          );
        }
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    close() {
      this.archiveMeasures = [];
      this.currentMeasures = [];
      this.isLoading = true;
    },
    editScadaPoint() {
      this.$root.$emit("sendScadaData", this.currentPoint);
      this.show("addScadaPointModal");
    },
    openScadaAlarms() {
      let url = `${this.scadaAlarmsLink}${this.currentPoint.code}`;
      window.open(url, "_blank");
    },
    showChart(unit, name, oid) {
      this.show("scadaChartModal");
      this.$root.$emit("passUnit", [unit, name, oid]);
    }
  },
  mounted() {
    const self = this;
    this.$root.$on("newPointAdded", value => {
      self.tempID = value;
    });

    this.$root.$on("getPointData", () => {
      self.open();
    });

    this.$root.$on("refreshPoint", data => {
      const self = this;
      self.currentPoint.code = data.body.code;
      self.currentPoint.name = data.body.name;
      self.currentPoint.description = data.body.description;
      this.$root.$emit("refreshScadaSource", data);
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/modals/ScadaPointCard.vue